import React,{useState} from 'react';
import { GlobeAltIcon, LockClosedIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'
import {addToDB} from '../Logic/index01'
import { BT, invalidChars, messageDisplay, State } from './Util';
import {Oval} from 'react-loader-spinner';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import towing from '../assets/mechanic.png'
import mechanic from '../assets/towing.png'
import '../index.css'



const Signup = () => {


const [isLoading, setisLoading] = useState(false)
const [email,setEmail] = useState("");
const [name,setName] = useState("");
const [password,setPassword] = useState("");
const [state, setStates] = useState('')
const [btype, setbtype] = useState('')
const [isOpen, setIsOpen] = useState(false)
const [isOpen2, setIsOpen2] = useState(false)
const [cpassword,setCPassword] = useState("");
const [phone,setPhone] = useState("");
const [platenum,setPlatenum] = useState("");
const [isValid, setIsValid] = useState(false);
const [ismailValid, setIsmailValid] = useState(false);
const [isAgree, setisAgree] = useState(false);
const [showPassword, setShowPassword] = useState(false);
const navigate = useNavigate();


const login = () => {
  up()
  navigate("/signin")
}



const handleToggle = (event) => {
    setisAgree(event.target.checked);
};



const up = () => {
     window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' 
    });
}




  const togglePassword = () => {
    setShowPassword(!showPassword);
  };




 const invalidChars = ["e", "E", "+", '-'];
const handleEvent = (e) =>{
  if (e.key.length > 1) {
    return; 
  }

  if (invalidChars.includes(e.key)) {
    e.preventDefault();
   }
  };




  const handlePlateno = (e) => {
    const upper = platenum.toUpperCase();
    const regex = /^[A-Z]{3}[- ]?[0-9]{3}[- ]?[A-Z]{2}$/;
    setIsValid(regex.test(upper));
    if(upper.length < 8 || !regex.test(upper)){
          messageDisplay("Invalid plate number",1);
    }
  };





  const handleEmail = (e) => {
    const em = email.toUpperCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setIsmailValid(emailRegex.test(em));
     if(em.length < 10 || !emailRegex.test(em)){
          messageDisplay("Invalid email number",1);
      }
  };





  function onSelection(option){
    setbtype(option);
    setIsOpen2(false)
    if(option === BT[1]){
      setIsValid(true)
      setPlatenum("aaa111bb")
    }else{
      setPlatenum("")
    }
  }

  




const sendOff = async () =>{
  if(password.toString() == cpassword.toString()){
     if(name.trim().length > 0 && email.trim().length > 0 && phone.trim().length > 0 && state.trim().length > 0 && btype.trim().length > 0){
       if(isAgree){
          if(ismailValid){    
              if(isValid){
                if(phone.length === 11){
                  setisLoading(true)
                  let res = await addToDB(name,email,password,phone,state,btype,platenum,isAgree);
                    messageDisplay(res.reason, res.reason.includes("already") ? 1 : 0)
                    if(res.reason === "Company account created."){
                        navigate("/signin")
                        setisLoading(false);
                    }else{
                      setisLoading(false)
                    }
                }else{
                  messageDisplay("Invalid phone number.",1)
                }
               }else{
                messageDisplay("Invalid plate number.",1)
               }
           }else{
             messageDisplay("Invalid email.",1)
          }
         }else{
            messageDisplay("Pls agree to the Terms and conditions.",1)
        }
    }else
          if(state.trim().length  <= 0){
            messageDisplay("Pls select what state your business is located.",1)
        }
        else
          if(btype.trim().length  <= 0){
            messageDisplay("Pls select business type.",1)
        }
        else{
            messageDisplay("Pls fill all fields",1)
        }
  }else{
    messageDisplay("Password does not match!",1)
  }
};







  return (
    <>
      <div class="relative flex h-auto min-h-screen w-full flex-col bg-background-light group/design-root">
                <div class="flex min-h-screen flex-1">
                <div class="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
                <div class="mx-auto w-full max-w-sm lg:w-96">
                <div>
                <div class="mt-0">
                <p class="text-text-primary text-4xl font-black leading-tight tracking-[-0.033em]">Create Your Account</p>
                <p class="text-[#5f7d8c] text-base font-normal leading-normal mt-2">Manage your business requests from one place.</p>
                </div>
                </div>

                <div class="mt-8">
                <div class="space-y-6">

                    <div>
                      <label class="block text-base font-medium leading-normal text-text-primary pb-2" for="full-name">Business Name</label>
                      <div class="relative">
                      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                      <span class="material-symbols-outlined text-brand-secondary">person</span>
                      </div>
                      <input value={name} onChange={(e) => setName(e.target.value)} class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-text-primary focus:outline-0 focus:ring-2 focus:ring-brand-primary/50 border border-[#dbe2e6] bg-white focus:border-brand-primary h-14 placeholder:text-text-secondary p-[15px] pl-11 text-base font-normal leading-normal" id="full-name" name="full-name" placeholder="Enter your Business name" type="text"/>
                      </div>
                    </div>

                    <div>
                      <label class="block text-base font-medium leading-normal text-text-primary pb-2" for="email">Email Address</label>
                      <div class="relative">
                      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                      <span class="material-symbols-outlined text-brand-secondary">mail</span>
                      </div>
                      <input onBlur={handleEmail} value={email} onChange={(e) => setEmail(e.target.value)} class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-text-primary focus:outline-0 focus:ring-2 focus:ring-brand-primary/50 border border-[#dbe2e6] bg-white focus:border-brand-primary h-14 placeholder:text-text-secondary p-[15px] pl-11 text-base font-normal leading-normal" id="email" name="email" placeholder="Enter your email address" type="email"/>
                      </div>
                    </div>

                    <div>
                      <label class="block text-base font-medium leading-normal text-text-primary pb-2" for="phone">Phone</label>
                      <div class="relative">
                      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                      <span class="material-symbols-outlined text-brand-secondary">phone</span>
                      </div>
                      <input value={phone}  onKeyDown={handleEvent}  onChange={(e) => setPhone(e.target.value)} class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-text-primary focus:outline-0 focus:ring-2 focus:ring-brand-primary/50 border border-[#dbe2e6] bg-white focus:border-brand-primary h-14 placeholder:text-text-secondary p-[15px] pl-11 text-base font-normal leading-normal" id="phone" name="phone" placeholder="Enter your phone number" type="number"/>
                      </div>
                    </div>



                    <div className="relative">
                        <input
                          type="text"
                          value={state}
                          onChange={(e) => {setStates(e.target.value); setIsOpen(true);}}
                          onFocus={() => setIsOpen(true)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg mt-5"
                          placeholder="Search Business State..."
                        />
                          {isOpen && (
                            <ul className="absolute w-full h-80 overflow-hidden  bg-white border rounded-lg shadow-lg z-10">
                              {State.filter(o => o.toLowerCase().includes(state.toLowerCase())).map(option => (
                                <li key={option} onClick={() => {setStates(option); setIsOpen(false);}}  onBlur={() => {setStates(option); setIsOpen(false)}} 
                                  className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                                  {option}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>




                      
                    <div className="relative">
                        <input
                          type="text"
                          value={btype}
                          onChange={(e) => {setbtype(e.target.value); setIsOpen2(true);}}
                          onFocus={() => setIsOpen2(true)}
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg mt-5"
                          placeholder="Business Type..."
                        />
                          {isOpen2 && (
                            <ul className="absolute w-full h-30 overflow-hidden  bg-white border rounded-lg shadow-lg z-10">
                              {BT.filter(o => o.toLowerCase().includes(btype.toLowerCase())).map(option => (
                                <li key={option} onClick={() => {onSelection(option)}}  onBlur={() => {onSelection(option)}} 
                                  className="px-4 py-2 cursor-pointer hover:bg-gray-100">
                                  {option}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>


                     {btype === BT[0] || btype === BT[2] ? 
                       <div>
                        <label class="block text-base font-medium leading-normal text-text-primary pb-2" for="phone">Plate number</label>
                        <div class="relative">
                          <div  class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                           <span class="material-symbols-outlined text-brand-secondary">directions_car</span>
                          </div>
                        <input value={platenum}  onBlur={handlePlateno}  onChange={(e) => setPlatenum(e.target.value)} class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-text-primary focus:outline-0 focus:ring-2 focus:ring-brand-primary/50 border border-[#dbe2e6] bg-white focus:border-brand-primary h-14 placeholder:text-text-secondary p-[15px] pl-11 text-base font-normal leading-normal" id="phone" name="phone" placeholder="Enter your plate number" type="text"/>
                        </div>
                      </div>
                     : null}


                    <div>
                      <label class="block text-base font-medium leading-normal text-text-primary pb-2" for="password">Password</label>
                      <div class="relative">
                      <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                      <span class="material-symbols-outlined text-brand-secondary">lock</span>
                      </div>
                      <input value={password} type={showPassword ? 'text' : 'password'}   onChange={(e) => setPassword(e.target.value)} class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-text-primary focus:outline-0 focus:ring-2 focus:ring-brand-primary/50 border border-[#dbe2e6] bg-white focus:border-brand-primary h-14 placeholder:text-text-secondary p-[15px] pl-11 pr-11 text-base font-normal leading-normal" id="password" name="password" placeholder="Create a password"/>
                      <button onClick={togglePassword}  class="absolute inset-y-0 right-0 flex justify-center items-center p-3 text-brand-secondary" type="button">
                        {!showPassword ? <span class="material-symbols-outlined cursor-pointer self-center">visibility</span>:  <span class="material-symbols-outlined cursor-pointer">visibility_off</span>}
                      </button>
                      </div>
                      </div>
                  <div>
                  <label class="block text-base font-medium leading-normal text-text-primary pb-2" for="confirm-password">Confirm Password</label>
                  <div class="relative">
                  <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <span class="material-symbols-outlined text-brand-secondary">lock</span>
                  </div>
                  <input value={cpassword}    type={showPassword ? 'text' : 'password'}     onChange={(e) => setCPassword(e.target.value)} class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-lg text-text-primary focus:outline-0 focus:ring-2 focus:ring-brand-primary/50 border border-[#dbe2e6] bg-white focus:border-brand-primary h-14 placeholder:text-text-secondary p-[15px] pl-11 pr-11 text-base font-normal leading-normal" id="confirm-password" name="confirm-password" placeholder="Confirm your password"/>
                   <button onClick={togglePassword}  class="absolute inset-y-0 right-0 flex justify-center items-center p-3 text-brand-secondary" type="button">
                        {!showPassword ? <span class="material-symbols-outlined cursor-pointer self-center">visibility</span>:  <span class="material-symbols-outlined cursor-pointer">visibility_off</span>}
                      </button>
                  </div>
                  </div>
                <div>

                   <div className='flex flex-row mb-10'>
                    <input 
                      type="checkbox" 
                      checked={isAgree} 
                      onChange={handleToggle} 
                      />
                     <div class=" text-xs text-brand-medium-gray dark:text-gray-500">
                      &nbsp; I agree to the <a class="hover:underline" href="#">Terms of Service</a> • <a class="hover:underline" href="#">Privacy Policy</a>
                    </div>
                </div>
                
                <button   disabled={isLoading ? true : false}  onClick={sendOff} class="flex w-full justify-center rounded-lg bg-blue-500 px-3 py-4 text-base font-semibold leading-6 text-white shadow-sm hover:bg-brand-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-primary" type="submit">
                  {isLoading ? <Oval strokeWidth={3} width={30} height={30} color='blue'/>  : "Register"}
                </button>
                </div>
                </div>
                <div class="mt-8 text-center text-sm text-text-secondary">
                <p>Already have an account? <a class="font-semibold text-brand-primary hover:text-brand-primary/90" onClick={login}>Log In</a></p>
                </div>
                </div>
                </div>
                </div>
                <div class="relative hidden w-0 flex-1 lg:block">
                     <div class="absolute inset-0  w-full bg-gradient-to-tr from-brand-primary to-brand-secondary  bg-black"></div>
                    <Carousel infiniteLoop={true} autoPlay={true}  showThumbs={false} >
                      <div>
                          <img src={mechanic} className='w-full h-full rounded-none' />
                      </div>
                      <div>
                          <img src={towing} className='w-full h-full rounded-none'/>
                      </div>
                    </Carousel>            
              </div>
            </div>
          </div>
    </>
  )
}

export default Signup
